module.exports = __webpack_public_path__ + "img/k12.95349b94.jpg";